import { inflate } from 'pako'

const decompressData = (encoded: string) => {
  try {
    // Convert from base64
    const compressed = Buffer.from(
      encoded.replace(/-/g, '+').replace(/_/g, '/'),
      'base64'
    )
    // Convert Buffer to Uint8Array and decompress
    const uint8Array = new Uint8Array(compressed)
    const decompressedData = inflate(uint8Array, { to: 'string' })
    const data = JSON.parse(decompressedData)

    // Convert back to original format
    if (Array.isArray(data)) {
      return data.map(bet => ({
        conditionId: bet.c, // conditionId
        outcomeId: bet.o, // outcomeId
        isExpressForbidden: bet.e, // isExpressForbidden
        transactionHash: bet.tx, // transactionHash
        chainId: bet.cid, // chainId
        odds: bet.od, // odds
        selectionName: bet.s, // selectionName
        game: bet.ga, // game
        marketName: bet.ma, // marketName
      }))
    } else {
      return {
        conditionId: data.c, // conditionId
        outcomeId: data.o, // outcomeId
        isExpressForbidden: data.e, // isExpressForbidden
        transactionHash: data.tx, // transactionHash
        chainId: data.cid, // chainId
        odds: data.od, // odds
        selectionName: data.s, // selectionName
        game: data.ga, // game
        marketName: data.ma, // marketName
      }
    }
  } catch (error) {
    console.error('Decompression error:', error)
    throw error
  }
}

export default decompressData
